import phoneCodeJson from '~variables/phone-code.json';
import _ from 'lodash';

const { list } = phoneCodeJson;

const formedPhoneCodes = list.map(phoneItem => ({
  label: `${phoneItem.phoneCode} (${phoneItem.name})`,
  value: phoneItem.phoneCode,
}));
const deduplicatePhoneCodes = formedPhoneCodes.filter((item, index) => {
  if (index !== 0 && _.isEqual(item, formedPhoneCodes[index - 1])) {
    return false;
  }
  return true;
});

export default deduplicatePhoneCodes;
